import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { adminGetMarketApi } from '../../../api/markets/adminGetMarketApi';
import { Market } from '../../../graphql/API';
import { useAdminRole } from '../../../hooks/useAdminRole';
import { useAppState } from '../../../hooks/useAppState';
import { appActions } from '../../../providers/AppStateContext';
import { icons } from '../../../themes/icons';
import { UserInfo } from './UserInfo';

export const Header: React.FC = () => {
  const { isCityManager, marketIds, marketId } = useAdminRole();
  const [, dispatch] = useAppState();

  const [availableData, setAvailableData] = React.useState([] as Array<Market>);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  React.useEffect(() => {
    Promise.all(marketIds.map((marketId) => adminGetMarketApi('' + marketId))).then((results) => {
      setAvailableData(results);
    });
  }, [marketIds]);

  const changeMarket = React.useCallback(
    (marketId) => {
      dispatch(appActions.setMarket(Number(marketId)));
      setAnchorEl(null);
    },
    [dispatch],
  );

  const selectedMarket = React.useMemo(
    () => availableData.find((market) => Number(market.id) === marketId),
    [availableData, marketId],
  );

  return (
    <Container>
      <Left>
        <Link to="/">
          <Logo src="/assets/admin-logo.png" />
        </Link>
        {isCityManager && availableData.length > 0 && (
          <>
            <MarketDropdownTrigger onClick={(e) => setAnchorEl(e.currentTarget)}>
              <span>{selectedMarket?.name || 'Select market'}</span>
              <icons.ExpandMoreIcon fontSize="small" />
            </MarketDropdownTrigger>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              {availableData.map((market) => (
                <MenuItem
                  key={market.id}
                  selected={Number(market.id) === marketId}
                  onClick={() => changeMarket(market.id)}
                >
                  {market.name}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
      </Left>
      <UserInfo />
    </Container>
  );
};

const Container = styled.div`
  ${({ theme }) => `
  align-items: center;
  background-color: ${theme.colors.white};
  display: flex;
  flex-flow: row nowrap;
  height: ${theme.sizes.headerHeight};
  justify-content: space-between;
  padding: 0.1rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${theme.zIndex.header};
  box-shadow:  0 1px 6px 0 rgb(0 0 0 / 2%);
  border-bottom: 1px solid #0000001f;
  // border-bottom: 1px solid  ${theme.colors.brandLightGrey};
`}
`;

const Left = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
`;

const MarketDropdownTrigger = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem 0.25rem 0.75rem;
  background: #f5f5f5;
  border-radius: 20px;
  color: black;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;

  svg {
    color: #888;
  }
`;

const Logo = styled.img`
  display: block;
  height: 31px;
  margin-left: 0.2rem;
  margin-right: 1rem;
`;
